/** Stored volume indices are permanent: existing offers and contracts use 0–11.
 * New bands are appended; selectors and comparisons use capacity order. */
export const LIVE_PRO360_25K_INDEX = 12;
export const VOLUME_TIERS = [
  50000, 200000, 300000, 400000, 500000, 550000, 600000, 650000, 700000, 800000, 900000, 1000000,
  25000,
];
export const VOLUME_LABELS = [
  "up to 50k", "up to 200k", "up to 300k", "up to 400k", "up to 500k", "up to 550k",
  "up to 600k", "up to 650k", "700k+", "800k+", "900k+", "1M+", "up to 25k",
];
export const VOLUME_TIER_ORDER = VOLUME_TIERS.map((_, index) => index)
  .sort((a, b) => VOLUME_TIERS[a]! - VOLUME_TIERS[b]!);

/** A product commitment is independent of its annual/quarterly invoice cadence. */
export function requiredContractTermMonths(lines: ReadonlyArray<{
  family: string | null;
  plan_key: string | null;
  volume_index?: number | null;
}>): number {
  return lines.some((line) => line.family === "live" && line.plan_key === "pro360" && line.volume_index === LIVE_PRO360_25K_INDEX)
    ? 24
    : 0;
}
